import _filter from 'lodash.filter';

export function filter<T = any, P = any>(collection: T[], predicate: P) {
  return _filter(collection, predicate);
}
